import { useQuery } from 'react-query';
import { getFeatureEnabled } from '../../services/featureService';

export function useFeatureEnabled(key: string) {
  return useQuery(['feature-enabled', key], () => getFeatureEnabled({ key }), {
    enabled: !!key,
    staleTime: 5 * 60 * 1000,
    cacheTime: 15 * 60 * 1000
  });
}
